import { configurationSources, loadConfiguration } from './rahlle-config.js';

if (!customElements.get('rahlle-shop-card')) {
  customElements.define('rahlle-shop-card', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.config = JSON.parse(this.querySelector('[data-card-config]').textContent);
      const photo = this.querySelector('.rs-image:not(.rs-image-alt)');
      this.originalImage = photo?.getAttribute('src');
      this.querySelectorAll('.rs-swatch').forEach(button => {
        button.disabled = false;
        const initialName = `${photo?.alt || ''} ${this.originalImage || ''}`.toLowerCase();
        button.setAttribute('aria-pressed', String(initialName.includes(`-${button.dataset.colour.toLowerCase()}-`)));
        button.addEventListener('click', () => this.selectColour(button), {signal: this.controller.signal});
      });
    }
    disconnectedCallback() { this.controller?.abort(); this.request = null; clearTimeout(this.loadingTimer); }
    async selectColour(button) {
      const data = button.dataset;
      const request = {};
      this.request = request;
      clearTimeout(this.loadingTimer);
      this.classList.remove('is-preview-loading');
      this.removeAttribute('aria-busy');
      this.querySelectorAll('.rs-swatch').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      this.querySelectorAll('.rs-media, h3 a').forEach(link => { link.href = data.url; });
      const price = this.querySelector('.rs-price');
      price.textContent = data.price;
      if (data.compare) { const compare = document.createElement('s'); compare.textContent = data.compare; price.append(compare); }
      const available = data.available === 'true';
      const stock = this.querySelector('.rs-stock');
      stock.textContent = available ? 'In stock' : 'Out of stock';
      stock.classList.toggle('rs-stock-out', !available);
      const badge = this.querySelector('.rs-badge');
      badge.hidden = available && !data.compare;
      badge.textContent = available ? 'Sale' : 'Sold out';
      badge.classList.toggle('rs-badge-sale', available);
      const config = this.querySelector('.rs-config');
      const photo = this.querySelector('.rs-image:not(.rs-image-alt)');
      const sources = configurationSources(this.config.configuration, this.config.options, JSON.parse(data.options));
      // Keep the current preview visible until its replacement is decoded.
      this.classList.add('rs-colour-selected');
      this.setAttribute('aria-busy', 'true');
      this.loadingTimer = setTimeout(() => {
        if (this.request === request) this.classList.add('is-preview-loading');
      }, 200);
      const showFallback = async () => {
        const showOriginal = () => {
          if (config) config.hidden = true;
          if (photo) photo.hidden = false;
        };
        if (!data.image) { showOriginal(); return; }
        const image = new Image();
        image.src = data.image;
        try { await image.decode(); } catch (error) {
          if (this.request === request) showOriginal();
          throw error;
        }
        if (this.request !== request) return;
        image.className = 'rs-image';
        image.alt = this.querySelector('h3').textContent.trim();
        this.querySelector('.rs-image:not(.rs-image-alt)')?.replaceWith(image);
        if (config) config.hidden = true;
      };
      try {
        if (!sources) {
          await showFallback();
        } else {
          const images = await loadConfiguration(sources);
          if (this.request !== request) return;
          config.replaceChildren(...images);
          config.setAttribute('role', 'img');
          config.setAttribute('aria-label', `${this.querySelector('h3').textContent.trim()} — ${data.colour}`);
          config.hidden = false;
          if (photo) photo.hidden = true;
        }
      } catch {
        if (this.request === request) {
          try { await showFallback(); } catch { /* Keep the available gallery image. */ }
        }
      } finally {
        if (this.request === request) {
          clearTimeout(this.loadingTimer);
          this.classList.remove('is-preview-loading');
          this.removeAttribute('aria-busy');
        }
      }
    }
  });
}
